import Vue from 'vue'
import Icon from './Icon'
import EmailInput from './form/EmailInput'
import ProgressBar from './ProgressBar'
import PasswordInput from './form/PasswordInput'
import SubmitButton from './form/SubmitButton'
import TextInput from './form/TextInput'
import NumberInput from './form/NumberInput'
import SelectInput from './form/SelectInput'
import SelectMultipleInput from './form/SelectMultipleInput'
import TextAreaInput from './form/TextAreaInput'
import RadioInput from './form/RadioInput'
import CheckInput from './form/CheckInput'
import DatePicker from './form/DatePicker'
import TimePicker from './form/TimePicker'
import {
  HasError,
  AlertError,
  AlertSuccess
} from 'vform'

Vue.component(Icon.name, Icon)
Vue.component(EmailInput.name, EmailInput)
Vue.component(ProgressBar.name, ProgressBar)
Vue.component(PasswordInput.name, PasswordInput)
Vue.component(SubmitButton.name, SubmitButton)
Vue.component(TextInput.name, TextInput)
Vue.component(HasError.name, HasError)
Vue.component(AlertError.name, AlertError)
Vue.component(AlertSuccess.name, AlertSuccess)
Vue.component(NumberInput.name, NumberInput)
Vue.component(SelectInput.name, SelectInput)
Vue.component(SelectMultipleInput.name, SelectMultipleInput)
Vue.component(TextAreaInput.name, TextAreaInput)
Vue.component(RadioInput.name, RadioInput)
Vue.component(CheckInput.name, CheckInput)
Vue.component(DatePicker.name, DatePicker)
Vue.component(TimePicker.name, TimePicker)



// WEBPACK FOOTER //
// ./resources/assets/js/components/index.js